module.exports = __webpack_public_path__ + "static/media/24pic.954d2748.jpg";